import { LightMode } from "@repo/skapa";

export const JoyrideStyles = {
  primaryColor: LightMode.colourStaticWhite,
  zIndex: 1000,
};
